import { addDays, isAfter, isBefore } from "date-fns";
import { get as lsGet, remove as lsRemove, set as lsSet } from "local-storage";
import store from "@/store";
import VerifyBillingTaxModal from "@/components/smart/modals/VerifyBillingTax";

const VERIFY_BILLING_DELAY = "verify-billing-delay";
const VERIFY_BILLING_COMPLETED = "verify-billing-completed";

// start showing modal for clients who started before Jun 19 2020
const startDate = new Date(2020, 6, 19);

const showModal = (client) => {
  // if client is not elligible to see billing modal
  if (!isBefore(client.startDate, startDate)) {
    return;
  }

  // if client has already completed billing info
  const completed = lsGet(`${VERIFY_BILLING_COMPLETED}:${client.id}`);
  if (completed) {
    return;
  }

  // if client has previously postponed warning, and delay has not expired
  const delayedAt = lsGet(`${VERIFY_BILLING_DELAY}:${client.id}`);
  // if a delay exists
  if (delayedAt !== null) {
    // if notice was delayed more than two days ago
    const expired = isAfter(new Date(), addDays(new Date(delayedAt), 2));
    // if still delayed
    if (!expired) {
      return;
    }
  }

  // show billing modal
  store.dispatch("modals/open", {
    template: VerifyBillingTaxModal,
  });
};

const postpone = (client) => {
  lsSet(`${VERIFY_BILLING_COMPLETED}:${client.id}`, false);
  lsSet(`${VERIFY_BILLING_DELAY}:${client.id}`, Date.now());
};

const complete = (client) => {
  lsSet(`${VERIFY_BILLING_COMPLETED}:${client.id}`, true);
  lsRemove(`${VERIFY_BILLING_DELAY}:${client.id}`);
};

export { showModal, postpone, complete };
